import React, {  useState } from "react"
import { Redirect } from 'react-router-dom'
import useUser from '../hooks/useUser'
import PasswordRecovery from "./PasswordRecovery"
import { Button, Alert, TextField, Typography, Link } from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton';
import Modal from '../components/Modal'
import PasswordInput from "../components/ui/PasswordInput"
import styles from './Login.module.scss'
import axios from "axios"

export default function Login() {
    const [statusCode, setStatusCode] = useState(false)
    const [Message, setMessage] = useState(false)
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [forgotPassword, setForgotPassword] = useState(false)
    const [ButtonLoading, setButtonLoading] = useState(false)
    const { login, isLoggedIn } = useUser()

    async function signin (event) {
        setButtonLoading(true)
        event.preventDefault()
        try{
            if (email && password) {
                // const res = await fetch('/api/users/login', {
                //     method: 'post',
                //     headers: { 'Content-Type': 'application/json' },
                //     body: JSON.stringify({ email, password })
                // })
                const data = await axios({
                    method: 'post',
                    url:'/api/users/login',
                    data:{ email, password }
                })
                // const data = await res.data;               
                if (data.status === 200) {
                    // localStorage.setItem('fe_token',data?.data?.token)
                    localStorage.setItem('FE_USER_DATA',JSON.stringify(data?.data))
                    // axios.defaults.headers.common['Authorization'] = `Bearer ${data?.data?.token}`  
                    login(data.data)
                    setStatusCode(false)
                } else {
                    setPassword('')
                    setStatusCode(data.status)
                    setMessage(data?.data?.result)
                }
            }
            else {
                setStatusCode(401)
            }
        }
        catch(error){
            setStatusCode(401)
        }
        finally{
            setButtonLoading(false)
        }
    }
    const showPopUp = () => {
       setForgotPassword(true)
       setPassword('')
    }

    const closePopUp = () => setForgotPassword(false)

    if (isLoggedIn) {
        return <Redirect to='/dashboard' />
    }

    const errorMessageList = {
        429: 'You have tried entering too many times. Please try again in 1 hour',
        401: 'The username or password provided were incorrect!',
        500: 'An error occurred while processing your request!',
        410: 'Your FE license has expired! Please contact our support team to renew it.',
        403: 'Your FE license has been deactivated! Please contact our support team to activate it.'
    }

    const errorMessage = () => (
        // statusCode && <Alert severity="error" classes={{root: styles['error']}}>{errorMessageList[statusCode]}</Alert>
        Message&& statusCode && <Alert severity="error" classes={{root: styles['error']}}>{Message}</Alert>
    )
    
    return (
        <div className={styles['container']}>
            {forgotPassword &&
                <Modal handleClose={closePopUp} open={forgotPassword} title="Password reset">
                    <PasswordRecovery/>
                </Modal>
            }
            <div className={styles['loginCard']}>
                <Typography variant="h1" classes={{root: styles['welcomeText']}}>Welcome</Typography>
                <Typography variant="h4" classes={{root: styles['subTitleText']}}>{`Please use your AltLab360 login details to log into Fundamental Edge`}</Typography>
                <form className={styles['form']} onSubmit={signin} >
                    <TextField id="email" placeholder="Email" variant="outlined" onChange={e => { setEmail(e.target.value) }} value={email} color="secondary" />
                    <PasswordInput password={password} setPassword={setPassword}/>
                    {/* <Button size="large" type="submit" classes={{root: styles['button']}} value="Submit" variant="contained" color="primary">Sign In</Button> */}
                    <LoadingButton 
                        loading={ButtonLoading}
                        size="large" 
                        type="submit" 
                        classes={{root: styles['button']}} 
                        value="Submit" 
                        variant="contained" 
                        color="primary"
                    >Sign In</LoadingButton>
                </form>
                {/* <Link onClick={showPopUp} color="inherit" id='passwordRecoveryLink'>Forgot Password?</Link> */}
                <Link onClick={()=>{window.open('https://lab360.althub.com/login')}} color="inherit" id='passwordRecoveryLink'>Forgot Password?</Link>
                {errorMessage()}
            </div>
        </div>
    )
}
